module.exports = __webpack_public_path__ + "assets/img/business.30e37b45.png";